import React, { useEffect, useState } from 'react';
import { ServiceItem } from '../redux/types';

import Axios from '../utils/axios';

const Services: React.FunctionComponent = () => {
	const [newService, setNewService] = useState<ServiceItem>({ name: '' });
	const [serviceItems, setServiceItems] = useState<ServiceItem[]>([]);

	const addService = async () => {
		newService.id
			? await Axios.put(`/service/${newService.id}`, newService)
			: await Axios.post(`/service/`, newService);
		await getData();
		setNewService({ name: '', price: 0 });
	};
	async function getData() {
		// add no cache header
		const res = await Axios.get(`/service/`, {
			headers: {
				'Cache-Control': 'no-cache'
			}
		});

		setServiceItems(res.data);
	}

	useEffect(() => {
		getData();
	}, [setServiceItems]);

	const removeMedicine = async (medicine: ServiceItem) => {
		if (window.confirm('از حذف دارو مطمئن هستید')) {
			await Axios.delete(`/service/${medicine.id}`);

			getData();
		}
	};

	return (
		<div className="m-5 text-lg">
			{/* callout */}
			<div
				className="px-4 py-3 text-blue-700 bg-blue-100 border border-blue-500 rounded-md shadow"
				role="alert"
			>
				<p className="font-bold">توجه</p>
				<p className="text-sm">ممکن است تغییرات خدمات با تاخیر مشاهده شود.</p>
			</div>
			<div className="flex flex-row mt-5 ">
				<div className="flex">
					<input
						type="text"
						className="p-2 ml-5 border-2 border-gray-300 rounded-lg"
						value={newService.name}
						placeholder="نام سرویس"
						onChange={(e) => setNewService({ name: e.target.value })}
					/>
					<input
						type="number"
						className="p-2 ml-5 border-2 border-gray-300 rounded-lg"
						value={newService.price}
						placeholder="هزینه سرویس"
						onChange={(e) =>
							setNewService({ ...newService, price: e.target.value as unknown as number })
						}
					/>
					<button
						className="px-4 py-2 ml-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
						onClick={addService}
					>
						{newService.id ? 'ویرایش' : 'افزودن'}
					</button>
				</div>
				<div className="flex"></div>
			</div>
			<table className="mt-10 bg-blue-100 border border-collapse shadow-lg table-auto border-slate-500">
				<thead className="text-gray-700 uppercase bg-blue-200">
					<tr className="">
						<th className="px-4 py-2 border border-slate-700 ">نام دارو</th>
						<th className="px-4 py-2 border border-slate-700 ">هزینه (تومان)</th>
						<th className="px-4 py-2 border border-slate-700 ">عملیات</th>
					</tr>
				</thead>
				<tbody>
					{serviceItems.map((service, i) => (
						<tr key={service.id} className={`hover:bg-blue-200 ${i % 2 && 'bg-blue-50'}`}>
							<td className="px-4 py-2 border border-slate-700 ">{service.name}</td>
							<td className="px-4 py-2 border border-slate-700 ">{service.price}</td>

							<td className="px-4 py-2 border border-slate-700">
								<button
									className="px-4 py-2 text-sm font-bold text-red-600 rounded border-slate-700 hover:text-red-900 "
									onClick={() => removeMedicine(service)}
								>
									حذف
								</button>
								<button
									className="px-4 py-2 text-sm font-bold text-blue-600 rounded border-slate-700 hover:text-blue-900 "
									onClick={() => setNewService(service)}
								>
									ویرایش
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default Services;
